
const convertRiceTypeENToTH = (riceParaGraph) => {
    const pairData = {
        'WhiteGlutinousRice10': {
          'TH': 'ข้าวเหนียวขาว10%',
          'EN': 'White  Glutinous Rice 10%',
        },
        'WhiteGlutinousRice25': {
          'TH': 'ข้าวเหนียวขาว25%',
          'EN': 'White  Glutinous Rice 25%',
        },
        'WhiteGlutinousBrokenRiceA1': {
          'TH': 'ข้าวเหนียวขาวหักเอวัน',
          'EN': 'White Glutinous Broken Rice A1',
        },
        'CargoRice5': {
          'TH': 'ข้าวกล้อง5%',
          'EN': 'Cargo Rice 5%',
        },
        'CargoRice10': {
          'TH': 'ข้าวกล้อง10%',
          'EN': 'Cargo Rice 10%',
        },
        'CargoRice15': {
          'TH': 'ข้าวกล้อง15%',
          'EN': 'Cargo Rice 15%',
        },
        'CargoRice100GradeA': {
          'TH': 'ข้าวกล้อง100%ชั้น1',
          'EN': 'Cargo Rice 100% Grade A',
        },
        'CargoRice100GradeB': {
          'TH': 'ข้าวกล้อง100%ชั้น2',
          'EN': 'Cargo Rice 100% Grade B',
        },
        'CargoRice100GradeC': {
          'TH': 'ข้าวกล้อง100%ชั้น3',
          'EN': 'Cargo Rice 100% Grade C',
        },
        'ThaiFragrantCargoRice5': {
          'TH': ['ข้าวกล้องหอมไทย5%', 'ข้าวกล้องหอมมะลิไทย5%'],
          'EN': 'Thai Fragrant Cargo Rice 5% ',
        },
        'ThaiFragrantCargoRice10': {
          'TH': ['ข้าวกล้องหอมไทย10%', 'ข้าวกล้องหอมมะลิไทย10%'],
          'EN': 'Thai Fragrant Cargo Rice 10% ',
        },
        'ThaiFragrantCargoRice15': {
          'TH': ['ข้าวกล้องหอมไทย15%', 'ข้าวกล้องหอมมะลิไทย15%'],
          'EN': 'Thai Fragrant Cargo Rice 15% ',
        },
        'ThaiFragrantCargoRice100': {
          'TH': ['ข้าวกล้องหอมไทย100%', 'ข้าวกล้องหอมมะลิไทย100%'],
          'EN': 'Thai Fragrant Cargo Rice 100% ',
        },
        'WhiteRice5': {
          'TH': 'ข้าวขาว5%',
          'EN': 'White Rice 5%',
        },
        'WhiteRice10': {
          'TH': 'ข้าวขาว10%',
          'EN': 'White Rice 10%',
        },
        'WhiteRice15': {
          'TH': 'ข้าวขาว15%',
          'EN': 'White Rice 15%',
        },
        'WhiteRice25': {
          'TH': 'ข้าวขาว25%',
          'EN': 'White Rice 25%',
        },
        'WhiteRice25Super': {
          'TH': 'ข้าวขาว5%เลิศ',
          'EN': 'White Rice 25% Super',
        },
        'WhiteRice35': {
          'TH': 'ข้าวขาว35%',
          'EN': 'White Rice 35%',
        },
        'WhiteRice45': {
          'TH': 'ข้าวขาว45%',
          'EN': 'White Rice 45%',
        },
        'WhiteRice100A': {
          'TH': 'ข้าวขาว100%ชั้น1',
          'EN': 'White Rice 100% A',
        },
        'WhiteRice100B': {
          'TH': 'ข้าวขาว100%ชั้น2',
          'EN': 'White Rice 100% B',
        },
        'WhiteRice100C': {
          'TH': 'ข้าวขาว100%ชั้น3',
          'EN': 'White Rice 100% C',
        },
        'WhiteBrokenRiceA1Super': {
          'TH': 'ข้าวขาวหักเอวันเลิศ',
          'EN': 'White Broken Rice A1 Super',
        },
        'WhiteBrokenRiceA1ExtraSuper': {
          'TH': 'ข้าวขาวหักเอวันเลิศพิเศษ',
          'EN': 'White Broken Rice A1 Extra Super',
        },
        'WhiteGlutinousRiceAsPerSample': {
          'TH': 'ข้าวเหนียวขาวตามตัวอย่าง',
          'EN': 'White  Glutinous Rice ( As Per Sample )',
        },
        'WhiteGlutinousBrokenRiceC1AsPerSample': {
          'TH': 'ข้าวเหนียวขาวหักซีวันตามตัวอย่าง',
          'EN': 'White Glutinous Broken Rice C1 ( As Per Sample )',
        },
        'WhiteGlutinousBrokenRiceAsPerSample': {
          'TH': 'ข้าวเหนียวขาวหักตามตัวอย่าง',
          'EN': 'White Glutinous Broken Rice ( As Per Sample )',
        },
        'BlackGlutinousRiceAsPerSample': {
          'TH': 'ข้าวเหนียวดำตามตัวอย่าง',
          'EN': 'Black Glutinous Rice ( As Per Sample )',
        },
        'CargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องตามตัวอย่าง',
          'EN': 'Cargo Rice ( As Per Sample)',
        },
        'ShortGrainCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องเมล็ดสั้นตามตัวอย่าง',
          'EN': 'Short Grain Cargo Rice ( As Per Sample )',
        },
        'JaponicaShortGrainCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องเมล็ดสั้นพันธุ์ญี่ปุ่นตามตัวอย่าง',
          'EN': 'Japonica Short Grain White Rice ( As Per Sample )',
        },
        'GlutinousCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องเหนียวตามตัวอย่าง',
          'EN': 'Glutinous Cargo Rice ( As Per Sample )',
        },
        'RedCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องแดงตามตัวอย่าง',
          'EN': 'Red Cargo Rice ( As Per Sample )',
        },
        'GerminateRedCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องแดงงอกตามตัวอย่าง',
          'EN': 'Germinate Red Cargo Rice ( As Per Sample )',
        },
        'GerminateCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องงอกตามตัวอย่าง',
          'EN': 'Germinate Cargo Rice ( As Per Sample )',
        },
        'SpecialMixedGerminateCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องงอกผสมพิเศษตามตัวอย่าง',
          'EN': 'Special Mixed Germinate Cargo Rice ( As Per Sample )',
        },
        'GerminateBlackCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องดำงอกตามตัวอย่าง',
          'EN': 'Germinate Black Cargo Rice ( As Per Sample )',
        },
        'BasmatiCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องบาสมาติตามตัวอย่าง',
          'EN': 'Basmati Cargo Rice ( As Per Sample )',
        },
        'SpecialMixedCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องผสมพิเศษตามตัวอย่าง',
          'EN': 'Special Mixed Cargo Rice ( As Per Sample )',
        },
        'ThaiFragrantCargoRiceAsPerSample': {
          'TH': 'ข้าวกล้องหอมไทยตามตัวอย่าง',
          'EN': 'Thai Fragrant Cargo Rice ( As Per Sample )',
        },
        'CargoBrokenRiceAsPerSample': {
          'TH': 'ข้าวกล้องหักตามตัวอย่าง',
          'EN': 'Cargo Broken Rice ( As Per Sample )',
        },
        'WhiteRice5AsPerSample': {
          'TH': 'ข้าวขาว5%ตามตัวอย่าง',
          'EN': 'White Rice 5% ( As Per Sample )',
        },
        'WhiteRice10AsPerSample': {
          'TH': 'ข้าวขาว10%ตามตัวอย่าง',
          'EN': 'White Rice 10% ( As Per Sample )',
        },
        'WhiteRice15AsPerSample': {
          'TH': 'ข้าวขาว15%ตามตัวอย่าง',
          'EN': 'White Rice 15% ( As Per Sample )',
        },
        'WhiteRice25AsPerSample': {
          'TH': 'ข้าวขาว25%ตามตัวอย่าง',
          'EN': 'White Rice 25% ( As Per Sample )',
        },
        'WhiteRice100AsPerSample' : {
          'TH' : 'ข้าวขาว100%ตามตัวอย่าง',
          'EN' : 'White Rice 100% ( As Per Sample )',
        },
        'WhiteRiceAsPerSample': {
          'TH': 'ข้าวขาวตามตัวอย่าง',
          'EN': 'White Rice ( As Per Sample )',
        },
        'WhiteRiceEnrichedVitaminAsPerSample': {
          'TH': 'ข้าวขาวเคลือบวิตามินตามตัวอย่าง',
          'EN': 'White Rice Enriched Vitamin ( As Per Sample )',
        },
        'ShortGrainWhiteRiceAsPerSample': {
          'TH': 'ข้าวขาวเมล็ดสั้นตามตัวอย่าง',
          'EN': 'Short Grain White Rice ( As Per Sample )',
        },
        'JaponicaShortGrainWhiteRiceAsPerSample': {
          'TH': 'ข้าวขาวเมล็ดสั้นพันธุ์ญี่ปุ่นตามตัวอย่าง',
          'EN': 'Japonica Short Grain White Rice ( As Per Sample )',
        },
        'BasmatiWhiteRiceAsPerSample': {
          'TH': 'ข้าวขาวบาสมาติตามตัวอย่าง',
          'EN': 'Basmati White Rice ( As Per Sample )',
        },
        'ThaiFragrantWhiteRiceAsPerSample': {
          'TH': 'ข้าวขาวหอมไทยตามตัวอย่าง',
          'EN': 'Thai Fragrant White Rice ( As Per Sample )',
        },
        'WhiteBrokenRiceC1AsPerSample': {
          'TH': 'ข้าวขาวหักซีวันตามตัวอย่าง',
          'EN': 'White Broken Rice C1 ( As Per Sample )',
        },
        'WhiteBrokenRiceAsPerSample': {
          'TH': 'ข้าวขาวหักตามตัวอย่าง',
          'EN': 'White Broken Rice ( As Per Sample )',
        },
        'WhiteBrokenRiceEnrichedVitaminAsPerSample': {
          'TH': 'ข้าวขาวหักเคลือบวิตามินตามตัวอย่าง',
          'EN': 'White Broken Rice Enriched Vitamin ( As Per Sample )',
        },
        'ParboiledRiceAsPerSample': {
          'TH': 'ข้าวนึ่งตามตัวอย่าง',
          'EN': 'Parboiled Rice ( As Per Sample )',
        },
        'CargoParboiledRiceAsPerSample': {
          'TH': 'ข้าวนึ่งกล้องตามตัวอย่าง',
          'EN': 'Cargo Parboiled Rice ( As Per Sample )',
        },
        'ParboiledBrokenRiceAsPerSample': {
          'TH': 'ข้าวนึ่งหักตามตัวอย่าง',
          'EN': 'Parboiled Broken Rice ( As Per Sample )',
        },
        'SpecialMixedRiceAsPerSample': {
          'TH': 'ข้าวผสมพิเศษตามตัวอย่าง',
          'EN': 'Special Mixed Rice ( As Per Sample )',
        },
        'ParboiledRice5': {
          'TH': 'ข้าวนึ่ง5%',
          'EN': 'Parboiled Rice 5%',
        },
        'ParboiledRice5Sorted': {
          'TH': 'ข้าวนึ่ง5%คัด',
          'EN': 'Parboiled Rice 5% Sorted',
        },
        'ParboiledRice10': {
          'TH': 'ข้าวนึ่ง10%',
          'EN': 'Parboiled Rice 10%',
        },
        'ParboiledRice10Sorted': {
          'TH': 'ข้าวนึ่ง10%คัด',
          'EN': 'Parboiled Rice 10% Sorted',
        },
        'ParboiledRice15': {
          'TH': 'ข้าวนึ่ง15%',
          'EN': 'Parboiled Rice 15%',
        },
        'ParboiledRice25': {
          'TH': 'ข้าวนึ่ง25%',
          'EN': 'Parboiled Rice 25%',
        },
        'ParboiledRice100': {
          'TH': 'ข้าวนึ่ง100%',
          'EN': 'Parboiled Rice 100%',
        },
        'ParboiledRice100Sorted': {
          'TH': 'ข้าวนึ่ง100%คัด',
          'EN': 'Parboiled Rice 100% Sorted',
        },
        'ParboiledBrokenRiceA1': {
          'TH': 'ข้าวนึ่งหักเอวัน',
          'EN': 'Parboiled Broken Rice A1',
        },
        'ThaiFragrantWhiteRice5': {
          'TH': ['ข้าวขาวหอมไทย5%', 'ข้าวขาวหอมมะลิไทย5%', 'ข้าวเจ้าขาวหอมมะลิไทย5%','ข้าวเจ้าข้าวหอมไทย5%'],
          'EN': 'Thai Fragrant White Rice 5% ',
        },
        'ThaiFragrantWhiteRice10': {
          'TH': ['ข้าวขาวหอมไทย10%', 'ข้าวขาวหอมมะลิไทย10%', 'ข้าวเจ้าขาวหอมมะลิไทย10%','ข้าวเจ้าข้าวหอมไทย10%'],
          'EN': 'Thai Fragrant White Rice 10% ',
        },
        'ThaiFragrantWhiteRice15': {
          'TH': ['ข้าวขาวหอมไทย15%', 'ข้าวขาวหอมมะลิไทย15%', 'ข้าวเจ้าขาวหอมมะลิไทย15%','ข้าวเจ้าข้าวหอมไทย15%'],
          'EN': 'Thai Fragrant White Rice 15% ',
        },
        'ThaiFragrantWhiteRice100': {
          'TH': ['ข้าวขาวหอมไทย100%', 'ข้าวขาวหอมมะลิไทย100%', 'ข้าวเจ้าขาวหอมมะลิไทย100%','ข้าวเจ้าข้าวหอมไทย100%'],
          'EN': 'Thai Fragrant White Rice 100% ',
        },
        'ThaiFragrantWhiteBrokenRiceA1Super': {
          'TH': 'ข้าวขาวหักเอวันเลิศข้าวหอมไทย',
          'EN': 'Thai Fragrant White Broken Rice A1 Super',
        },
        'ThaiFragrantWhiteBrokenRiceA1ExtraSuper': {
          'TH': ['ข้าวขาวหักเอวันเลิศพิเศษข้าวหอมไทย', 'ปลายข้าวข้าวขาวหอมมะลิไทยเอวันเลิศพิเศษ','ปลายข้าวข้าวเจ้าขาวหอมไทยเอวันเลิศพิเศษ','ปลายข้าวข้าวขาวหอมไทยเอวันเลิศพิเศษ'],
          'EN': 'Thai Fragrant White Broken Rice A1 Extra Super',
        },
        'RedGlutinousCargoRiceAsPerSample':{
          'TH':['ข้าวกล้องเหนียวสีแดงตามตัวอย่าง'],
          'EN':'Red Glutinous Cargo Rice ( As Per Sample )',
        },
        'RedGlutinousCargoRicePrimeQuality':{
          'TH':'ข้าวกล้องเหนียวสีแดงชั้นดีเลิศ',
          'EN':'Red Glutinous Cargo Rice Prime Quality',
        },
        'RedGlutinousCargoRiceSuperbQuality':{
          'TH':'ข้าวกล้องเหนียวสีแดงชั้นดีพิเศษ',
          'EN':'Red Glutinous Cargo Rice Superb Quality',
        },
        'BlackGlutinousCargoRiceAsPerSample':{
          'TH':'ข้าวกล้องเหนียวสีดำสีม่วงดำและสีม่วงตามตัวอย่าง',
          'EN':'Black Glutinous Cargo Rice ( As Per Sample )',
        },
        'BlackGlutinousCargoRiceStandardQuality':{
          'TH':'ข้าวกล้องเหนียวสีดำสีม่วงดำและสีม่วงชั้นมาตรฐาน',
          'EN':'Black Glutinous Cargo Rice Standard Quality',
        },
        'BlackGlutinousCargoRiceBestQuality':{
          'TH':'ข้าวกล้องเหนียวสีดำสีม่วงดำและสีม่วงชั้นดี',
          'EN':'Black Glutinous Cargo Rice Best Quality',
        },
        'RedCargoRicePrimeQuality':{
          'TH':'ข้าวกล้องเจ้าสีแดงชั้นดีเลิศ',
          'EN':'Red Cargo Rice Prime Quality',
        },
        'RedCargoRiceSuperbQuality':{
          'TH':'ข้าวกล้องเจ้าสีแดงชั้นดีพิเศษ',
          'EN':'Red Cargo Rice Superb Quality',
        },
        'BlackCargoRiceAsPerSample':{
          'TH':'ข้าวกล้องเจ้าสีดำสีม่วงดำและสีม่วงตามตัวอย่าง',
          'EN':'Black Cargo Rice ( As Per Sample )',
        },
        'BlackCargoRicePrimeQuality':{
          'TH':'ข้าวกล้องเจ้าสีดำสีม่วงดำและสีม่วงชั้นดีเลิศ',
          'EN':'Black Cargo Rice Prime Quality',
        },
        'BlackCargoRiceSuperbQuality':{
          'TH':'ข้าวกล้องเจ้าสีดำสีม่วงดำและสีม่วงชั้นดีพิเศษ',
          'EN':'Black Cargo Rice Superb Quality',
        },
      }
    try {
        if(Array.isArray(pairData[riceParaGraph]['TH'])) {
            return pairData[riceParaGraph]['TH'][0]
        }
        else if (pairData[riceParaGraph] === undefined) {
            return 'error'
        }
        else {
            return pairData[riceParaGraph]['TH']
        }    
    } catch (error) {
        return ''
    }
}
module.exports.exportExcelDaily = (dataIn)=>{
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    
    let ws_data = [['ลำดับ','ทะเบียนงาน','ชื่อบริษัทส่งออก','สถานที่','เวลาบรรุทก','พนักงานตรวจข้าว / ต่อ','พนักงานตรวจข้าว / ต่อ'
,'ชื่อพาหนะ','ประเทศปลายทาง','เลขที่ใบอนุญาต','รายการที่','ชนิดข้าว','ปริมาณ / ตัน','ชื่อบริษัทเซอร์เวย์']]

    dataIn.map((data,idz)=>{
      console.log(data)
        Object.keys(data['description']).map((idx)=>{
          if(data['description'][idx] != null){
            let countryArr = []
            countryArr.push(parseInt(idz) + 1)
            countryArr.push(data['jobID'])
            countryArr.push(data['companyID'])
            countryArr.push(`${data['surveyLocateName']} - ${data['surveyDistrict']} - ${data['surveyProvince']}`)
            countryArr.push(`${data['shippingTime']} น.`)
            countryArr.push(`${data['officerID']} ${data['chainID']}`)
            countryArr.push(`${data['officerID2']} ${data['chainID']}`)
            try {
              countryArr.push(data['description'][idx]['vehicleName'])
            } catch (error) {
              countryArr.push('')
            }
            try {
              countryArr.push(data['description'][idx]['destinationCity'])
            } catch (error) {
              countryArr.push('')
            }
            countryArr.push(data['description'][idx]['licenseID'])
            countryArr.push(parseInt(data['description'][idx]['subID']) +1)
            countryArr.push(data['description'][idx]['riceTypeName'])
            countryArr.push(data['description'][idx]['quantity'])
            countryArr.push(data['description'][idx]['surveyCompany'])
            ws_data.push(countryArr)
          }
        })
    })    
    var ws = XLSX.utils.aoa_to_sheet(ws_data)
    XLSX.utils.book_append_sheet(wb, ws, ws_name)
    XLSX.writeFile(wb,`บันทึกแจ้งงาน.xlsx`)

    console.log('hello')
}

module.exports.updateState = (RequestComplete,RequestJobComplete,viewAllOfficer,viewAllCompany)=>{
  let arr = []
  Object.keys(RequestComplete).map((title)=>{
      if(title !== 'countJobID'){
      if(typeof RequestComplete[title] == 'object' && !RequestJobComplete['message']){
          if(!RequestComplete['message']){
          let temp = Object.values(RequestJobComplete).filter((e)=>{return e['requestID'] == RequestComplete[title]['requestID'] })
          if(temp.length != 0){
              RequestComplete[title]['jobID'] = temp[0]['jobID']
              RequestComplete[title]['chainID'] = temp[0]['chainID']
              RequestComplete[title]['officerID'] = temp[0]['officerID']
              RequestComplete[title]['officerID2'] = temp[0]['officerID2']
              arr = arr.concat([RequestComplete[title]])
          }else{
              RequestComplete[title]['officerID'] = ''
              RequestComplete[title]['officerID2'] = ''
              arr = arr.concat([RequestComplete[title]])
          }
          }
      }
      }
  })
  Object.values(viewAllOfficer).map((Checker)=>{
      let id = Checker['ID'] 
      arr.forEach((data)=>{
      if(data['officerID'] == id ){
          data['officerID']  = `${parseInt(Checker['userName'])+1}. ${Checker['fName']}`
      }
      if(data['officerID2'] == id ){
          data['officerID2']  = `${parseInt(Checker['userName'])+1}. ${Checker['fName']} `
      }
      if(data['officerID2'] == '' ){
          data['officerID2']  = `-`
      }
      })
  })
  Object.values(viewAllCompany).map((Company)=>{
      let id = Company['companyID'] 
      arr.forEach((data)=>{
      if(data['companyID'] == id ){
          data['companyID']  = `${Company['companyNameEN']}`
      }
      })
  })
  var riceDescriptionArr = {}
  arr.sort((a,b) => (a['requestID'] > b['requestID']) ? 1 : ((b['requestID'] > a['requestID']) ? -1 : 0))
  arr.forEach((data,idx)=>{
      if(data['chainID'] !== 'none'){
      let temp = arr.filter((e)=>{return e['requestID'] == data['chainID'] })
      if(temp.length != 0){
          data['chainID'] = `/ ต่อ Job NO:${temp[0]['jobID']}`
      }    
      }else{
      data['chainID'] = ``
      }
      if(data['jobID']){
        console.log(data['jobID'])
      }
      // console.log(data)
      if(data['description']){
      data['description'].sort((a,b)=>{
          if(a){
              if(b){
              // console.log(a['riceTypeID'] > b['riceTypeID'])
              if(a['riceTypeID'] < b['riceTypeID']) {
                  return -1 
              }
              if(a['riceTypeID'] > b['riceTypeID']){
                  return 1
              }  
              else{
                  return 0
              }
              }
          }
      })
      Object.values(data['description']).map((dataDescription)=>{
        if(dataDescription != null && typeof dataDescription == 'object'){
          console.log(data,idx)
          // riceDescriptionArr = {
          //     ...riceDescriptionArr,
          //     [idx] : {
          //       ...riceDescriptionArr[idx],
          //     }
          // }
          // riceDescriptionArr = {
          //     [idx] : {
          //     [dataDescription['riceTypeID']] : (()=>{
          //         if(riceDescriptionArr[idx]){
          //         if(!riceDescriptionArr[idx][dataDescription['riceTypeID']]){
          //             return  (Math.round(parseFloat(dataDescription['quantity']) * 1000)/1000).toFixed(4)
          //         }else { 
          //             return  (parseFloat(dataDescription['quantity']) + parseFloat(riceDescriptionArr[idx][dataDescription['riceTypeID']])).toFixed(4)
          //         }
          //         }
          //     })(),
          //     [`Total${dataDescription['riceTypeID']}`] : (()=>{
          //         if(riceDescriptionArr[idx]){
          //         if(!riceDescriptionArr[idx][`Total${dataDescription['riceTypeID']}`]){
          //             return  1
          //         }else { 
          //             return 1 + (riceDescriptionArr[idx][`Total${dataDescription['riceTypeID']}`])
          //         }
          //         }
          //     })()
          //     }
          // }  
        }
    })

    }
  })
  return arr,riceDescriptionArr
}

module.exports.renderRequestPDF = (data,doc,font,convertRiceTypeENToTH,riceTypeIDAndName)=>{
  console.log(data)
  doc.addFileToVFS('THSarabun-normal.ttf', font.addFont());
  doc.addFont('THSarabun-normal.ttf', 'THSarabun', 'normal');
  doc.setFont('THSarabun')
  doc.setFontType('normal');
  doc.setFontSize(16)
  doc.text('หนังสือแจ้งขอตรวจสอบ', 85, 14)
  doc.text(`คำสั่งจ่ายงานเลขที่ ${data['jobID']}`,160,12)
  doc.text(`${data['officerID']}`,177,17,{maxWidth: 40, align: 'center'})
  doc.text('วันที่', 145, 24)
  doc.text(data['requestDate'],155,24)
  doc.text('ด้วยบริษัท', 45, 34)
  doc.text(data['companyID'],65,34,{maxWidth: 70, align: 'justify'})
  doc.text('มีความประสงค์จะส่งข้าวออกนอก', 135, 34)
  doc.text('ราชอาณาจักร ดังมีรายการนี้', 35, 44)

  doc.setFontSize(12)
  doc.text('รายการที่', 25, 54)
  doc.text('ใบอนุญาต', 40, 54)
  doc.text('ประเภท ชนิด และชั้น', 55, 54)
  doc.text('ปริมาณ', 85, 54)
  doc.text('บรรจุใน', 96, 54)
  doc.text('GrossWeight', 107, 54)
  doc.text('NettWeight', 123, 54)
  doc.text('เครื่องหมาย', 140, 54)
  doc.text('บรรทุกลงเรือ', 157, 54)
  doc.text('เมืองตราส่ง', 175, 54)
  // doc.text('โทร ', 140, 189)
  let lineHeight = 59
  Object.values(data['description']).map((descriptionData)=>{
    let subID = `${parseInt(descriptionData['subID']) + 1}`
    let licenseID = descriptionData['licenseID']
    let riceTypeName = descriptionData['riceTypeName'] || convertRiceTypeENToTH(descriptionData['riceTypeID'],riceTypeIDAndName,'standalone')
    let quantity = (parseFloat(descriptionData['quantity'])).toFixed(4)
    let grossWeight = `${parseFloat(descriptionData['grossWeight']).toFixed(2)}`
    let netWeight = `${parseFloat(descriptionData['netWeight']).toFixed(2)}`
    let mask = descriptionData['mask'] || ''
    let vehicleName = descriptionData['vehicleName'] || ''
    let destination = descriptionData['Destination'] || ''
    let productDes = descriptionData['ProductDescription'] || ''
    doc.setFontSize(8)
    // doc.text('รายการที่', 25, 74)
    // doc.text('ใบอนุญาต', 40, 74)
    // doc.text('ประเภท ชนิด และชั้น', 55, 74)
    // doc.text('ปริมาณ', 85, 74)
    // doc.text('บรรจุใน', 96, 74)
    // doc.text('น้ำหนักหน่วย', 107, 74)
    // doc.text('น้ำหนักหน่วย', 123, 74)
    // doc.text('เครื่องหมาย', 140, 74)
    // doc.text('บรรทุกลงเรือ', 157, 74)
    // doc.text('เมืองตราส่ง', 175, 74)
    console.log(subID,licenseID,riceTypeName,quantity,grossWeight,netWeight,mask,vehicleName,destination)
    doc.text(subID, 30, lineHeight)
    doc.text(licenseID,36,lineHeight)
    doc.text(riceTypeName,55,lineHeight,{maxWidth: 27, align: 'justify'})
    doc.text(quantity,85,lineHeight)
    doc.text(grossWeight,107,lineHeight)
    doc.text(netWeight,123,lineHeight)
    doc.text(mask,140,lineHeight)
    doc.text(vehicleName,157,lineHeight)
    doc.text(destination,175,lineHeight)
    doc.setFontSize(7)
    lineHeight += 6
    doc.text(productDes.replace(/(\r\n|\n|\r)/gm, ""),55,lineHeight)
    lineHeight += 4
  })  
  lineHeight += 5
  doc.setFontSize(16)
  doc.text('วันเวลาที่จะบรรทุกลงในยานพาหนะ : วันที่ ', 40, lineHeight)
  doc.text(data['shippingDate'] , 110,lineHeight)
  doc.text('ตั้งแต่เวลา ', 140, lineHeight)
  doc.text(data['shippingTime'] , 160,lineHeight)
  lineHeight += 10
  doc.text('สถานที่ตรวจสอบ (ที่จะบรรทุกข้าว) : ', 40, lineHeight)
  doc.text(data['surveyLocateName'], 100,lineHeight)
  doc.text('โทร ', 160, lineHeight)
  doc.text(data['tel'] , 170,lineHeight )
  lineHeight += 10
  // doc.text('ชื่อผู้ประกอบธุรกิจตรวจสอบ (เซอร์เวย์) ถ้ามี : ', 40, lineHeight)
  // lineHeight += 10
  doc.text('ผู้รับผิดชอบในการจ่ายเงินค่าบริการการตรวจสอบข้าว', 40, lineHeight)
  doc.text(data['companyID'], 130, lineHeight)

  doc.output('dataurlnewwindow')
  
}